import Vue from 'vue';
import Vuex from 'vuex';

const state = {
  params: {
    page: 1,
    per_page: 30,
    q: {
      name: '',
      activity_name: '',
      source: [],
      point_type: '',
      created_start_time: (new Date().getTime() - 3600 * 1000 * 24 * 30) / 1000,
      created_end_time: new Date().getTime() / 1000,
    }
  },
  downData: []
};

const mutations = {
  changePointsPage(state, val) {
    state.params = val;
  },
  changeDownList(state, val) {
    state.downData = val;
  }
};

export default {
  state,
  mutations
};
